import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import * as coreResourceApi from '../services/resourceApi';
import * as uiStateApi from '../services/uiStateApi'; // Import the new service

const defaultApis = {
  resource: coreResourceApi,
  uiState: uiStateApi, // Expose it here
};

const ApiContext = createContext(defaultApis);

/**
 * Provides API services to the entire application.
 * Merges app-specific APIs with core defaults.
 */
export const ApiProvider = ({ children, apis }) => {
  const mergedApis = useMemo(() => ({
    ...defaultApis,
    ...apis,
    // Ensure nested objects (like resource) are merged, not overwritten
    resource: {
      ...defaultApis.resource,
      ...(apis?.resource || {}),
    },
    // Ensure uiState is merged if the app tries to extend it (though unlikely)
    uiState: {
        ...defaultApis.uiState,
        ...(apis?.uiState || {}),
    }
  }), [apis]);

  return (
    <ApiContext.Provider value={mergedApis}>
      {children}
    </ApiContext.Provider>
  );
};

ApiProvider.propTypes = {
  children: PropTypes.node.isRequired,
  apis: PropTypes.object.isRequired,
};

/**
 * Hook to access the registered API services.
 * @returns {object} The collection of API services.
 */
export const useApi = () => useContext(ApiContext);